import { createApiSlice } from "@common";
import { CRUD_PRODUCT_TYPE } from "@routes";

const apiConfig = [
  { name: "addProductType",    method: "post",   url: CRUD_PRODUCT_TYPE, stateKey: "message" },
  { name: "getProductType",    method: "get",    url: CRUD_PRODUCT_TYPE, stateKey: "data"    },
  { name: "updateProductType", method: "put",    url: CRUD_PRODUCT_TYPE, stateKey: "message" },
  { name: "deleteProductType", method: "delete", url: CRUD_PRODUCT_TYPE, stateKey: "message" },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("productType", apiConfig, customReducers);
const productTypeSlice = slice;

export default productTypeSlice.reducer;

export const { addProductType, getProductType, updateProductType, deleteProductType } = thunks;
export const { rowSelect } = actions;
